import React, { useState, useEffect } from 'react';
import { Switch } from '../../../../../components/buttons';
import moment from 'moment';
import DatePicker from "react-datepicker";

export default function (props) {
    const [ view, setView ] = useState(false);
    const multiplier = 86400000;
    const initialState = {
        from:new Date(new Date().getTime() - parseInt(30*multiplier)),
        to:new Date(new Date().getTime() + parseInt(1*multiplier))
    };
    const [ date, setDate ] = useState(initialState);

    useEffect(() => {
        if (props.startDate) {
            setDate({
                ...date,
                from:new Date(moment(props.startDate).format()),
                to:new Date(moment(props.endDate).format())
            })
        }
    },[props.startDate,props.endDate]);

    const onSetDate = (type,d) => {
        if (type === 'from') {
            setDate({...date, from:d})    
            props.onChange({...date, from:d});
        } else {
            setDate({...date, to:d})
            props.onChange({...date, to:d});
        }   
    };

    return (
        <div className="border-bottom">
            <div className={`${view ? null : "filter-view"}`}>
                <div className="py-3 container">
                    <div 
                        className="pointer row justify-content-between px-4" 
                        onClick={props.open ? props.onClickOpen : props.onClickClose}
                        >
                            Tanggal pembuatan order
                    </div>
                </div>
            </div>
            {
                props.open ? 
                    <div className="bg-lighter p-4">
                        <div className="form-row">
                            <div className="col-6">
                                <label>Tanggal Awal</label>
                                <DatePicker
                                    className="form-control mb-0"
                                    onChange={e => onSetDate('from',e)}
                                    selected={date.from}
                                />
                            </div>
                            <div className="col-6">
                                <label>Tanggal Akhir</label>
                                <DatePicker
                                    className="form-control mb-0"
                                    onChange={e => onSetDate('to',e)}
                                    selected={date.to}
                                />
                            </div>
                        </div>
                    </div>
                    : 
                    null
            }
        </div>
    )
};